import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M20.423 14.625a.399.399 0 00.285-.135.42.42 0 00.082-.308l-1.117-6a.375.375 0 00-.368-.307H4.695a.375.375 0 00-.367.307l-1.118 6a.42.42 0 00.083.308.397.397 0 00.285.135h16.845zM3.375 15.375A.375.375 0 003 15.75v2.438a1.687 1.687 0 001.688 1.687.188.188 0 01.187.188v.375a.562.562 0 101.125 0v-.188a.375.375 0 01.375-.375h11.25a.375.375 0 01.375.375v.188a.562.562 0 101.125 0v-.375a.188.188 0 01.188-.188A1.687 1.687 0 0021 18.187V15.75a.375.375 0 00-.375-.375H3.375zM19.5 4.688A1.687 1.687 0 0017.812 3H6.188A1.687 1.687 0 004.5 4.688V6.75a.375.375 0 00.375.375H6.06a.375.375 0 00.368-.315l.27-1.62a.375.375 0 01.367-.315H10.5a.375.375 0 01.375.375v1.5a.375.375 0 00.375.375h1.5a.375.375 0 00.375-.375v-1.5a.375.375 0 01.375-.375h3.435a.375.375 0 01.367.315l.27 1.62a.375.375 0 00.368.315h1.185a.375.375 0 00.375-.375V4.687z",
      fill: "#333"
    }
  )
), t = l;
export {
  t as default
};
